<template>
  <div class="inline-block bg-white rounded">
    <router-link v-if="linkTo" :to="linkTo">
      <div
        class="py-2 px-4 saoltext text-np-light bg-np-glimpse rounded whitespace-nowrap hover:opacity-80"
      >
        {{ text }}
      </div>
    </router-link>
    <a v-else @click="downloadFile" class="cursor-pointer">
      <div
        class="py-2 px-4 saoltext text-np-light bg-np-glimpse rounded whitespace-nowrap hover:opacity-80"
      >
        {{ text }}
      </div>
    </a>
  </div>
</template>
<script>
import { getStaticFileBySlug } from "@/api/endpoints/staticfiles";
import to from "await-to-js";

export default {
  name: "NeeraSolidButton",
  props: {
    text: {
      type: [String],
    },
    linkTo: {
      type: [String],
    },
    staticFileSlug: {
      type: [String],
    },
  },
  methods: {
    async downloadFile() {
      const [err, response] = await to(getStaticFileBySlug(this.staticFileSlug))

      var url
      if(response.data.data[0].attributes.content.length > 0){
        // IF component is File get url from file
        if(response.data.data[0].attributes.content[0].__component === "static-file.upload-file"){
          url = response.data.data[0].attributes.content[0].file.data.attributes.url
        }else{ //IF component is url get data from field url
          url = response.data.data[0].attributes.content[0].url
        }
      }else{
         url = response.data.data[0].attributes.file.data.attributes.url
      }      
      if (this.$vssWidth >= 1024) {
        window.open(url);
      } else {
        window.location.href = url;
      }
    },
  },
};
</script>
